import React, {useContext, useState} from 'react';
import '../Keyboard.css';
import {ThemeContext} from "../../../../../providers/themeContext/theme-context.tsx";
// 引入样式文件

type KeyProps = {
    label: string;
    onPress: (label: string) => void;
    rowNum: number;
    wrongLetters: string[];
}

const LetterKey: React.FC<KeyProps> = ({label, onPress, rowNum, wrongLetters}) => {
    // 主题全局管理器
    const {imgUrls} = useContext(ThemeContext);
    const [pressed, setPressed] = useState(false);
    const [isWrong, setIsWrong] = useState(true);

    React.useEffect(() => {
        const lowerLatter = label.toLowerCase();
        if (wrongLetters.includes(lowerLatter)) {
            setIsWrong(true);
        } else {
            setIsWrong(false);
        }
    }, [label, wrongLetters]);


    const handleKeyPress = () => {
        setPressed(true);
        setTimeout(() => setPressed(false), 200); // 按键后的状态持续时间
        onPress(label);
    };

    return (
        <div
            className={`my-roboto-medium ${isWrong ? 'keyboard-key-wrong' : ''} ${rowNum == 1 ? ' keyboard-first-letter-container' : rowNum == 2 ? 'keyboard-second-letter-container' : 'keyboard-third-letter-container'} ${pressed ? 'key-pressed' : ''}`}
            style={{
                backgroundImage: `url(${
                    rowNum == 1 ? imgUrls.firstKeyboardBtnUrl : rowNum == 2 ? imgUrls.secondKeyboardBtnUrl : imgUrls.thirdKeyboardBtnUrl
                })`
            }}
            onClick={handleKeyPress}>
            {label}
        </div>
    );
};

export default LetterKey;